import React from 'react';
import { Box, Typography } from '@mui/material';
import BarChart from './BarChart';
import LineChart from './LineChart';
import RadarChart from './RadarChart';

const PlayerCharts = ({ weeklyData = [], drillData = [], role = "player" }) => {
  const chartHeight = role === "admin" ? 350 : 250;
  const radarHeight = role === "admin" ? 400 : 300;

  return (
    <Box sx={{ mt: 4, display: 'flex', flexDirection: 'column', gap: 6 }}>
      <Box>
        <Typography variant="h6" gutterBottom>
          Weekly Makes vs Attempts
        </Typography>
        <Box sx={{ width: '100%', height: chartHeight }}>
          <BarChart data={weeklyData ?? []} />
        </Box>
      </Box>

      <Box>
        <Typography variant="h6" gutterBottom>
          Shooting % by Week
        </Typography>
        <Box sx={{ width: '100%', height: chartHeight }}>
          <LineChart data={weeklyData ?? []} />
        </Box>
      </Box>

      <Box>
        <Typography variant="h6" gutterBottom>
          Accuracy by Drill
        </Typography>
        <Box sx={{ width: '100%', height: radarHeight }}>
          <RadarChart data={drillData ?? {}} />
        </Box>
      </Box>
    </Box>
  );
};

export default PlayerCharts;



